import { ITaskStageUseCase, ITaskStage } from "@lib";
import { ITaskStageCreateDto, ITaskStageUpdateDto } from "@lib";
import { DataLoadException } from "@/core/exceptions";
import { Api } from "../axios";

export class TaskStageUseCase implements ITaskStageUseCase {
    public async select(companyId: string): Promise<ITaskStage[]> {
        try {
            const response = await Api.get<ITaskStage[]>(`/companies/${companyId}/lists/taskstages`);
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async get(companyId: string, id: string): Promise<ITaskStage> {
        try {
            const response = await Api.get<ITaskStage>(`/companies/${companyId}/lists/taskstages/${id}`);
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async create(companyId: string, dto: ITaskStageCreateDto): Promise<ITaskStage> {
        try {
            const response = await Api.post<ITaskStage>(`/companies/${companyId}/lists/taskstages`, dto);
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async createMany(companyId: string, dtos: ITaskStageCreateDto[]): Promise<ITaskStage[]> {
        try {
            const response = await Api.post<ITaskStage[]>(`/companies/${companyId}/lists/taskstages/many`, dtos);
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async update(companyId: string, id: string, dto: ITaskStageUpdateDto): Promise<ITaskStage> {
        try {
            const response = await Api.put<ITaskStage>(`/companies/${companyId}/lists/taskstages/${id}`, dto);
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async archive(companyId: string, id: string): Promise<void> {
        try {
            await Api.delete<void>(`/companies/${companyId}/lists/taskstages/${id}`);
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }
}
